export const LoadingSvg = ({ isLoading = false }: { isLoading?: boolean }) => {
  return (
    <svg
      width="293"
      height="201"
      viewBox="0 0 293 201"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-56 sm:w-[293px]"
    >
      <foreignObject x="15.6822" y="-19.6543" width="254.046" height="184">
        <div
          style={{
            backdropFilter: "blur(16.73px)",
            clipPath: "url(#bgblur_1_3795_116337_clip_path)",
            height: "100%",
            width: "100%",
          }}
        ></div>
      </foreignObject>
      <g
        filter="url(#filter0_d_3795_116337)"
        data-figma-bg-blur-radius="33.4545"
      >
        <g clipPath="url(#clip0_3795_116337)">
          <rect
            x="49.1367"
            y="13.8003"
            width="187.136"
            height="117.091"
            rx="10.4545"
            fill="#3C3C3D"
            fillOpacity="0.9"
            shapeRendering="crispEdges"
          />
          <rect
            x="49.1367"
            y="13.8003"
            width="187.136"
            height="117.091"
            rx="10.4545"
            fill="url(#paint0_linear_3795_116337)"
            fillOpacity="0.08"
            shapeRendering="crispEdges"
          />
          <rect
            x="44.9551"
            y="6.48145"
            width="66.9091"
            height="134.864"
            fill="white"
            fillOpacity="0.04"
          />
          <rect
            x="45.4778"
            y="7.00417"
            width="65.8636"
            height="133.818"
            stroke="white"
            strokeOpacity="0.07"
            strokeWidth="1.04545"
          />
          <rect
            x="57.5"
            y="30.5269"
            width="43.9091"
            height="6.27273"
            rx="3.13636"
            fill="white"
            fillOpacity="0.1"
          />
          <rect
            x="122.318"
            y="30.5269"
            width="59.5909"
            height="6.27273"
            rx="3.13636"
            fill="white"
            fillOpacity="0.17"
          />
          <rect
            opacity="0.5"
            x="122.318"
            y="43.0723"
            width="41.8182"
            height="6.27273"
            rx="3.13636"
            fill="white"
            fillOpacity="0.12"
          />
          <rect
            x="57.5"
            y="45.1631"
            width="28.2273"
            height="6.27273"
            rx="3.13636"
            fill="white"
            fillOpacity="0.2"
          />
          <rect
            opacity="0.5"
            x="57.5"
            y="59.7998"
            width="32.4091"
            height="6.27273"
            rx="3.13636"
            fill="white"
            fillOpacity="0.1"
          />
          <rect
            x="57.5"
            y="74.436"
            width="39.7273"
            height="6.27273"
            rx="3.13636"
            fill="white"
            fillOpacity="0.1"
          />
          <rect
            x="124.41"
            y="59.7998"
            width="99.3182"
            height="64.8182"
            rx="6.27273"
            fill="black"
            fillOpacity="0.16"
          />
          <rect
            x="123.365"
            y="58.7544"
            width="101.409"
            height="66.9091"
            rx="7.31818"
            stroke="white"
            strokeOpacity="0.1"
            strokeWidth="2.09091"
            strokeDasharray="2.09 4.18"
          />
        </g>
        <rect
          x="49.6594"
          y="14.323"
          width="186.091"
          height="116.045"
          rx="9.93182"
          stroke="url(#paint1_linear_3795_116337)"
          strokeWidth="1.04545"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#filter1_dddd_3795_116337)">
        <path
          d="M230.177 43.5775L249.55 47.7255C250.474 47.9229 250.625 49.1816 249.773 49.5919L241.772 53.4482L240.266 62.2013C240.106 63.1345 238.856 63.3358 238.41 62.4996L229.093 45.0154C228.696 44.2707 229.352 43.4003 230.177 43.5775Z"
          fill="#444445"
        />
        <path
          d="M230.177 43.5775L249.55 47.7255C250.474 47.9229 250.625 49.1816 249.773 49.5919L241.772 53.4482L240.266 62.2013C240.106 63.1345 238.856 63.3358 238.41 62.4996L229.093 45.0154C228.696 44.2707 229.352 43.4003 230.177 43.5775Z"
          stroke="#CFD0D2"
          strokeWidth="1.84091"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <foreignObject x="124.409" y="52.482" width="177.727" height="129.636">
        <div
          style={{
            backdropFilter: "blur(16.73px)",
            clipPath: "url(#bgblur_2_3795_116337_clip_path)",
            height: "100%",
            width: "100%",
          }}
        ></div>
      </foreignObject>
      <g data-figma-bg-blur-radius="33.4545">
        <rect
          x="158.363"
          y="86.4365"
          width="109.818"
          height="61.7273"
          rx="7.95"
          fill="#3C3C3D"
          fillOpacity="0.9"
        />
        <rect
          x="158.363"
          y="86.4365"
          width="109.818"
          height="61.7273"
          rx="7.95"
          fill="url(#paint2_linear_3795_116337)"
          fillOpacity="0.08"
        />
        <rect
          x="158.363"
          y="86.4365"
          width="109.818"
          height="61.7273"
          rx="7.95"
          stroke="url(#paint3_linear_3795_116337)"
        />
        <path
          d="M168.318 101.619C168.318 99.8871 169.723 98.4829 171.455 98.4829H244.637C246.369 98.4829 247.773 99.8871 247.773 101.619C247.773 103.351 246.369 104.756 244.637 104.756H171.455C169.723 104.756 168.318 103.351 168.318 101.619Z"
          fill="white"
          fillOpacity="0.21"
        />
        <path
          opacity="0.7"
          d="M168.318 117.301C168.318 115.569 169.723 114.165 171.455 114.165H217.455C219.187 114.165 220.591 115.569 220.591 117.301C220.591 119.033 219.187 120.437 217.455 120.437H171.455C169.723 120.437 168.318 119.033 168.318 117.301Z"
          fill="white"
          fillOpacity="0.11"
        />
        <path
          d="M168.318 132.983C168.318 131.251 169.723 129.847 171.455 129.847H232.091C233.823 129.847 235.227 131.251 235.227 132.983C235.227 134.715 233.823 136.119 232.091 136.119H171.455C169.723 136.119 168.318 134.715 168.318 132.983Z"
          fill="white"
          fillOpacity="0.11"
        />
      </g>
      <foreignObject
        x="0.000526428"
        y="-20.6998"
        width="292.727"
        height="221.637"
      >
        <div
          style={{
            backdropFilter: "blur(12.55px)",
            clipPath: "url(#bgblur_3_3795_116337_clip_path)",
            height: "100%",
            width: "100%",
          }}
        ></div>
      </foreignObject>
      <g
        filter="url(#filter3_ddddddd_3795_116337)"
        data-figma-bg-blur-radius="25.0909"
      >
        <rect
          x="79.4551"
          y="4.39111"
          width="133.818"
          height="18.8182"
          rx="9.40909"
          fill="white"
          fillOpacity="0.08"
          shapeRendering="crispEdges"
        />
        <rect
          x="79.9551"
          y="4.89111"
          width="132.818"
          height="17.8182"
          rx="8.90909"
          stroke="url(#paint4_linear_3795_116337)"
          strokeOpacity="0.2"
          shapeRendering="crispEdges"
        />
        <rect
          x="79.9551"
          y="4.89111"
          width="132.818"
          height="17.8182"
          rx="8.90909"
          stroke="url(#paint5_linear_3795_116337)"
          strokeOpacity="0.3"
          shapeRendering="crispEdges"
        />
        <rect
          x="118.682"
          y="10.5278"
          width="56"
          height="6"
          rx="3"
          fill="white"
          fillOpacity="0.1"
        />
        <rect
          x="199.682"
          y="9.61865"
          width="8.36364"
          height="8.36364"
          rx="4.18182"
          fill="white"
          fillOpacity="0.1"
        />
        <rect
          x="84.6816"
          y="10.8013"
          width="6"
          height="6"
          rx="3"
          fill="white"
          fillOpacity="0.1"
        />
        <rect
          x="92.6816"
          y="10.8013"
          width="6"
          height="6"
          rx="3"
          fill="white"
          fillOpacity="0.1"
        />
        <rect
          x="100.682"
          y="10.8013"
          width="6"
          height="6"
          rx="3"
          fill="white"
          fillOpacity="0.1"
        />
      </g>
      <foreignObject x="13.5907" y="85.9364" width="79.4553" height="79.4548">
        <div
          style={{
            backdropFilter: "blur(12.55px)",
            clipPath: "url(#bgblur_4_3795_116337_clip_path)",
            height: "100%",
            width: "100%",
          }}
        ></div>
      </foreignObject>
      <g data-figma-bg-blur-radius="25.0909">
        <rect
          x="38.6816"
          y="111.027"
          width="29.2727"
          height="29.2727"
          rx="14.6364"
          fill="white"
          fillOpacity="0.08"
        />
        <rect
          x="39.1816"
          y="111.527"
          width="28.2727"
          height="28.2727"
          rx="14.1364"
          stroke="url(#paint6_linear_3795_116337)"
          strokeOpacity="0.2"
        />
        <rect
          x="39.1816"
          y="111.527"
          width="28.2727"
          height="28.2727"
          rx="14.1364"
          stroke="url(#paint7_linear_3795_116337)"
          strokeOpacity="0.3"
        />
        <g>
          {isLoading && (
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="0 53.3184 125.662"
              to="360 53.3184 125.662"
              dur="1.5s"
              repeatCount="indefinite"
            />
          )}
          <path
            d="M61.9918 125.662C61.9918 120.872 58.1086 116.989 53.3184 116.989V118.615C57.2104 118.615 60.3655 121.77 60.3655 125.662C60.3655 129.554 57.2104 132.709 53.3184 132.709V134.336C58.1086 134.336 61.9918 130.452 61.9918 125.662Z"
            fill="url(#paint8_linear_3795_116337)"
          />
          <path
            d="M46.2708 125.662C46.2708 121.77 49.4259 118.615 53.3179 118.615V116.989C48.5277 116.989 44.6445 120.872 44.6445 125.662C44.6445 130.452 48.5277 134.336 53.3179 134.336V132.709C49.4259 132.709 46.2708 129.554 46.2708 125.662Z"
            fill="url(#paint9_linear_3795_116337)"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_3795_116337"
          x="15.6822"
          y="-19.6543"
          width="254.046"
          height="184"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="0.95"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_3795_116337"
          />
          <feOffset dy="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.14902 0 0 0 0 0.14902 0 0 0 0 0.14902 0 0 0 0.8 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3795_116337"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3795_116337"
            result="shape"
          />
        </filter>
        <clipPath
          id="bgblur_1_3795_116337_clip_path"
          transform="translate(-15.6822 19.6543)"
        >
          <rect
            x="49.1367"
            y="13.8003"
            width="187.136"
            height="117.091"
            rx="10.4545"
          />
        </clipPath>
        <filter
          id="filter1_dddd_3795_116337"
          x="221.522"
          y="42.6328"
          width="36.2635"
          height="36.0056"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="2.45455"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_3795_116337"
          />
          <feOffset dy="4.90909" />
          <feGaussianBlur stdDeviation="2.45455" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.145098 0 0 0 0 0.145098 0 0 0 0 0.152941 0 0 0 0.04 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3795_116337"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.22727"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_3795_116337"
          />
          <feOffset dy="2.45455" />
          <feGaussianBlur stdDeviation="1.22727" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.145098 0 0 0 0 0.145098 0 0 0 0 0.152941 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_3795_116337"
            result="effect2_dropShadow_3795_116337"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.39618" />
          <feGaussianBlur stdDeviation="1.35847" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.145098 0 0 0 0 0.145098 0 0 0 0 0.152941 0 0 0 0.01 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_dropShadow_3795_116337"
            result="effect3_dropShadow_3795_116337"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="8.16149" />
          <feGaussianBlur stdDeviation="3.2646" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.145098 0 0 0 0 0.145098 0 0 0 0 0.152941 0 0 0 0.0183 0"
          />
          <feBlend
            mode="normal"
            in2="effect3_dropShadow_3795_116337"
            result="effect4_dropShadow_3795_116337"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect4_dropShadow_3795_116337"
            result="shape"
          />
        </filter>
        <clipPath
          id="bgblur_2_3795_116337_clip_path"
          transform="translate(-124.409 -52.482)"
        >
          <rect
            x="158.363"
            y="86.4365"
            width="109.818"
            height="61.7273"
            rx="7.95"
          />
        </clipPath>
        <filter
          id="filter3_ddddddd_3795_116337"
          x="0.000526428"
          y="-20.6998"
          width="292.727"
          height="221.637"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.71946" />
          <feGaussianBlur stdDeviation="1.09936" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0196802 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3795_116337"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="6.53524" />
          <feGaussianBlur stdDeviation="2.6419" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0282725 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_3795_116337"
            result="effect2_dropShadow_3795_116337"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="12.3053" />
          <feGaussianBlur stdDeviation="4.97447" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.035 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_dropShadow_3795_116337"
            result="effect3_dropShadow_3795_116337"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="21.9505" />
          <feGaussianBlur stdDeviation="8.87361" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0417275 0"
          />
          <feBlend
            mode="normal"
            in2="effect3_dropShadow_3795_116337"
            result="effect4_dropShadow_3795_116337"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="41.056" />
          <feGaussianBlur stdDeviation="16.5971" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0503198 0"
          />
          <feBlend
            mode="normal"
            in2="effect4_dropShadow_3795_116337"
            result="effect5_dropShadow_3795_116337"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="98.2727" />
          <feGaussianBlur stdDeviation="39.7273" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
          />
          <feBlend
            mode="normal"
            in2="effect5_dropShadow_3795_116337"
            result="effect6_dropShadow_3795_116337"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.04545"
            operator="erode"
            in="SourceAlpha"
            result="effect7_dropShadow_3795_116337"
          />
          <feOffset dy="3.13636" />
          <feGaussianBlur stdDeviation="4.28636" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="effect6_dropShadow_3795_116337"
            result="effect7_dropShadow_3795_116337"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect7_dropShadow_3795_116337"
            result="shape"
          />
        </filter>
        <clipPath
          id="bgblur_3_3795_116337_clip_path"
          transform="translate(-0.000526428 20.6998)"
        >
          <rect
            x="79.4551"
            y="4.39111"
            width="133.818"
            height="18.8182"
            rx="9.40909"
          />
        </clipPath>
        <clipPath
          id="bgblur_4_3795_116337_clip_path"
          transform="translate(-13.5907 -85.9364)"
        >
          <rect
            x="38.6816"
            y="111.027"
            width="29.2727"
            height="29.2727"
            rx="14.6364"
          />
        </clipPath>
        <linearGradient
          id="paint0_linear_3795_116337"
          x1="142.705"
          y1="13.8003"
          x2="142.705"
          y2="130.891"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3795_116337"
          x1="142.705"
          y1="13.8003"
          x2="142.705"
          y2="130.891"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.12" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3795_116337"
          x1="213.272"
          y1="85.9365"
          x2="213.272"
          y2="148.664"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3795_116337"
          x1="213.272"
          y1="85.9365"
          x2="213.272"
          y2="148.664"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.12" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_3795_116337"
          x1="106.895"
          y1="4.39111"
          x2="108.234"
          y2="10.808"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_3795_116337"
          x1="213.273"
          y1="24.1816"
          x2="210.414"
          y2="13.3149"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_3795_116337"
          x1="44.6842"
          y1="111.027"
          x2="49.5121"
          y2="114.282"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_3795_116337"
          x1="67.9544"
          y1="141.812"
          x2="60.4407"
          y2="137.797"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_3795_116337"
          x1="53.3184"
          y1="118.615"
          x2="53.3184"
          y2="133.522"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CFD0D2" stopOpacity="0.5" />
          <stop offset="1" stopColor="#CFD0D2" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_3795_116337"
          x1="53.3179"
          y1="118.615"
          x2="53.3179"
          y2="133.522"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CFD0D2" stopOpacity="0.5" />
          <stop offset="1" stopColor="#CFD0D2" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_3795_116337">
          <rect
            x="49.1367"
            y="13.8003"
            width="187.136"
            height="117.091"
            rx="10.4545"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
